export const pageContainerSx = {
  margin: '0 auto',
  minHeight: 'calc(100vh - 190px)',
};

export const paddingTopSx = {
  paddingTop: '90px',
};
